import { Component, OnInit, Inject, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SignDocumentService } from 'src/app/core/services/sign-document.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { map, first } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-confirm-sign-otp',
  templateUrl: './confirm-sign-otp.component.html',
  styleUrls: ['./confirm-sign-otp.component.scss']
})
export class ConfirmSignOtpComponent implements OnInit, OnDestroy, AfterViewInit {
  sign = {
    contractId: '',
    otp: null,
    transactionId: ''
  };

  success = false;

  // Refer to form in view
  @ViewChild('f', { static: false }) ngForm: NgForm;

  // Whether the form change or not
  isFormChanging = false;

  show = true;

  // Subscribe to form changing
  formChangesSubscription: Subscription;

  constructor(
    private signDocumentService: SignDocumentService,
    private dialogRef: MatDialogRef<ConfirmSignOtpComponent>,
    private notificationService: NotificationService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private message: Message,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  /**
   * Init component
   */
  ngOnInit() {
    this.sign.contractId = this.data.documentId;
    this.sign.transactionId = this.data.transaction;
    this.notificationService.subscribeErrorService();
  }

  /**
   * Destroy component
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
  }

  /**
   * Confirm sign OTP
   */
  confirmSignOtp() {
    this.signDocumentService.signOtp(this.sign).subscribe(rs => {
      // this.toastr.success(this.message.getMessage('messages.sign_success'));
      this.success = true;
      this.dialogRef.close();
    });
  }

  /**
   * Send code OTP again
   */
  onSendCodeOTPAgain() {
    this.signDocumentService.generateTransaction(this.data.documentId, this.data.selectedPhone, this.data.request).subscribe(rs => {
      this.sign.transactionId = rs.data;
      this.toastr.success(this.message.getMessage('messages.send_code_otp_again'));
    });
  }

  /**
   * Close dialog
   */
  onNoClick() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.show = false;
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

  /**
   * Confirm before navigation
   */
  canDeactivate() {
    const tenantId = localStorage.getItem('tenantId');
    if ((this.isFormChanging && this.show && tenantId != null)
      || (this.show && tenantId != null)) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      return dialogRe.afterClosed().pipe(map(result => {
        if (result) {
          return true;
        } else {
          return false;
        }
      }), first());
    } else {
      return true;
    }
  }

  /**
   * Init after view comp
   */
  ngAfterViewInit() {
    this.formChangesSubscription = this.ngForm.form.statusChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });
  }
}
